import { render, staticRenderFns } from "./ChatRoomPublic.vue?vue&type=template&id=36bcf516&scoped=true&"
import script from "./ChatRoomPublic.vue?vue&type=script&lang=js&"
export * from "./ChatRoomPublic.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomPublic.vue?vue&type=style&index=0&id=36bcf516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bcf516",
  null
  
)

export default component.exports